import { useContext, createContext } from 'react';
import { types, onSnapshot } from 'mobx-state-tree';

import { OTP } from './OTP';

const RootModel = types.model({
    otp: OTP,
});

export const rootStore = RootModel.create({
    otp: {
        loading: false,
    },
})

onSnapshot(rootStore, snapshot => console.log("Snapshot: ", snapshot))

const RootStoreContext = createContext(RootModel);
export const Provider = RootStoreContext.Provider;
export const useMst = () => {
    const store = useContext(RootStoreContext);
    if (store === null) {
        throw new Error("Store cannot be null, please add a context provider");
    }

    return store;
}
